// The section title shown beside the brand mark on a non-home mobile route (PO: "never empty space beside the
// logo — all pages show their name except the dashboard"). The routed screen drops its own page title (see
// `Page`, which suppresses it below `lg`) and the header carries the section name instead.
//
// Keyed on the FIRST path segment, so a sub-route (`/assets/brand`, `/releases/{id}`) resolves to its
// section. Labels match the server nav's `MobileLabel`, which is the canonical product vocabulary
// ("Socials" for content, "Streaming" for music). Home ("/") and any unmapped segment return null — home is
// the deliberate exception, and a route with no title here keeps whatever its screen renders.

const SEGMENT_TITLE: Record<string, string> = {
  socials: "Socials",
  music: "Streaming",
  releases: "Releases",
  messages: "Inbox",
  assets: "Assets",
  advance: "Advance Docs",
  contacts: "Contacts",
  marketing: "Marketing",
  antenna: "Antenna",
  calendar: "Calendar",
  booking: "Booking",
  shows: "Shows",
  dos: "DOS",
  settings: "Settings",
  notifications: "Notifications",
  profile: "Profile",
  "road-cases": "Road cases",
  buses: "Buses",
  debug: "Debug",
};

/** The title beside the logo for a mobile route, or null for home / an unmapped route. */
export function mobileSectionTitle(pathname: string): string | null {
  // A friend/band profile reads as its own section — "Friend", not "Contacts" (ART-195, per Ryan). A known
  // sub-route wins over the first-segment fallback. The CONTACT profile keeps "Contacts" (ART-194 mockup), so
  // it needs no override — it falls through to the first-segment lookup below.
  if (pathname.startsWith("/contacts/band/")) return "Friend";
  // The door check-in page reads as its own section — "Guest List", not the "Shows" of its `/shows/{id}/…`
  // parent (Ryan, ART-174). A known sub-route wins over the first-segment fallback.
  if (/^\/shows\/[^/]+\/guests(\/|$)/.test(pathname)) return "Guest List";
  const seg = pathname.split("/")[1] ?? ""; // "" for "/"
  return SEGMENT_TITLE[seg] ?? null;
}
